import React from 'react';

export const TypingIndicator = () => {
  return (
    <div className="flex justify-start mb-4">
      <div className="flex flex-col items-start max-w-[80%]">
        <div className="bg-slate-100 rounded-2xl rounded-tl-sm px-4 py-3">
          <div className="flex space-x-1.5">
            <div className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
        <span className="text-xs text-slate-400 mt-1 px-1">
          Digian is typing...
        </span>
      </div>
    </div>
  );
};
